// Shared enums for Mekân & Organizatör forms (Turkish UI)
export const EVENT_TYPES = [
  'Atölye',
  'Konferans',
  'Konser',
  'Sergi',
  'Workshop',
  'Doğum Günü',
  'Düğün',
  'Toplantı',
  'Lansman',
  'Networking',
  'Diğer',
];

export const DAYS = [
  'Pazartesi',
  'Salı',
  'Çarşamba',
  'Perşembe',
  'Cuma',
  'Cumartesi',
  'Pazar',
];

export const TECHNICAL = [
  'WiFi',
  'Projeksiyon',
  'Ses Sistemi',
  'Mikrofon',
  'Sahne',
  'Aydınlatma',
  'Kamera',
  'Klima',
  'Beyaz Tahta',
  'TV Ekran',
];

// All 39 Istanbul districts (İlçeler)
export const DISTRICTS = [
  // European side (Avrupa Yakası)
  'Arnavutköy',
  'Avcılar',
  'Bağcılar',
  'Bahçelievler',
  'Bakırköy',
  'Başakşehir',
  'Bayrampaşa',
  'Beşiktaş',
  'Beylikdüzü',
  'Beyoğlu',
  'Büyükçekmece',
  'Çatalca',
  'Esenler',
  'Esenyurt',
  'Eyüpsultan',
  'Fatih',
  'Gaziosmanpaşa',
  'Güngören',
  'Kâğıthane',
  'Küçükçekmece',
  'Sarıyer',
  'Silivri',
  'Sultangazi',
  'Şişli',
  'Zeytinburnu',
  // Asian side (Anadolu Yakası)
  'Adalar',
  'Ataşehir',
  'Beykoz',
  'Çekmeköy',
  'Kadıköy',
  'Kartal',
  'Maltepe',
  'Pendik',
  'Sancaktepe',
  'Sultanbeyli',
  'Şile',
  'Tuzla',
  'Ümraniye',
  'Üsküdar',
];

export const BUDGET_MODELS = [
  { value: 'kira_yok_min_harcama', label: 'Kira yok / minimum harcama' },
  { value: 'sabit_kira_kabul', label: 'Sabit kira kabul ederim' },
  { value: 'depozito_kabul', label: 'Depozito kabul ederim' },
  { value: 'sadece_ucretsiz', label: 'Sadece ücretsiz mekân isterim' },
];
